import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundary } from './bundle/ErrorBoundary/ErrorBoundary';
import { QueryClientApp } from './bundle/QueryClient';
import { sentryService } from './services/sentryService';
import { StyleSheetManager, WebTarget } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import { isString } from '@/helpers/objectHelpers';
import './index.css';
import 'react-tooltip/dist/react-tooltip.css';

sentryService.init();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <StyleSheetManager
        // Skip rendering custom non-native HTML props in DOM
        shouldForwardProp={(propName: string, elementToBeRendered: WebTarget) => {
          return isString(elementToBeRendered) ? isPropValid(propName) : true;
        }}
      >
        <ErrorBoundary>
          <QueryClientApp />
        </ErrorBoundary>
      </StyleSheetManager>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
